const modules = import.meta.glob("./*.js", { eager: true });

const quizMap = {};
for (const path in modules) {
  if (path === "./index.js") continue;
  const slug = path.replace("./", "").replace(".js", "");
  quizMap[slug] = modules[path].questions;
}

/**
 * @param {string} [slug]
 * @returns {Array}
 */
export function getQuestions(slug) {
  const key = slug || window.quizSlug || "questions";
  const questions = quizMap[key];
  if (!questions) {
    console.error(`Quiz "${key}" not found. Available: ${Object.keys(quizMap).join(", ")}`);
    return [];
  }
  return questions;
}
